module.exports = function isPrimitive(value) {
	return value === null || (typeof value !== 'function' && typeof value !== 'object');
};



//////////////////
// WEBPACK FOOTER
// ../node_modules/es-to-primitive/helpers/isPrimitive.js
// module id = 785
// module chunks = 0